const fonts = {
  heading: "'Montserrat', sans-serif",
  body: "'Montserrat', sans-serif",
};

export default fonts;
